import { render } from "./VuetableRowHeader.vue?vue&type=template&id=597fd364"
import script from "./VuetableRowHeader.vue?vue&type=script&lang=js"
export * from "./VuetableRowHeader.vue?vue&type=script&lang=js"

import exportComponent from "D:\\www\\Centroid\\Frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__